import { Button, useNotify } from 'react-admin';
import ModalComponent from '../../../../components/ModalComponent';

const ResetPasswordModal = ({ open, onClose , userId, email = ""}) => {
  const notify = useNotify();

  const handleResetPassword = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}/users/${userId}/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) throw new Error('Erro ao enviar e-mail');

      notify("E-mail de redefinição de senha enviado com sucesso", { type: "success" });
      onClose();
    } catch (error) {
      notify("Falha no envio do e-mail de redefinição de senha", { type: "error" });
      onClose();
    }
  };

  return (
    <div>
      <ModalComponent
        open={open}
        onClose={onClose}
        title="Confirmar Envio de Redefinição de Senha"
        content={
          <p >
            Você está prestes a enviar um e-mail com um link para redefinição de senha para o usuário <span style={{ fontWeight: "bold" }}>{email}</span>. Esta ação é irreversível. Deseja prosseguir?
          </p>
        }
        actions={
          <>
            <Button onClick={onClose} label="Cancelar" />
            <Button onClick={handleResetPassword} label="Enviar" />
          </>
        }
      />
    </div>
  );
};

export default ResetPasswordModal;
